module.exports = __webpack_public_path__ + "static/media/gitlab.d8fe0705.svg";